export function convert(array) {
	console.log("convertArrayToTree convert array.length", array.length);
	var map = {};
	for (var i = 0; i < array.length; i++) {
		var obj = array[i];
		obj.children = [];

		map[obj.id] = obj;

		var parent = obj.parent || "-";
		if (!map[parent]) {
			map[parent] = {
				children: [],
			};
		}
		map[parent].children.push(obj);
	}
	let outputvalue;
	try {
		outputvalue = map["-"].children;
	} catch (e) {}

	return outputvalue;
}

function convert2(array) {
	console.log("convert array.length", array.length);
	var map = {};
	for (var i = 0; i < array.length; i++) {
		var obj = array[i];
		obj.children = [];

		map[obj.id] = obj;

		var parent = obj.parent || "-";
		if (!map[parent]) {
			map[parent] = {
				children: [],
			};
		}
		map[parent].children.push(obj);
	}

	return map["-"].children;
}
